/*
 * @Author: chenchaoqiang@leedarson.com
 * @Date: 2022-08-09 09:44:27
 * Copyright 2022 Leedarson, All Rights Reserved.
 */
export const TOKEN = 'token'; // 登录token 过期需要置换token
export const ACCESS_TOKEN_RESPONSE_PARAM = 'accessToken';
export const REFRESH_TOKEN = 'refreshToken'; // 置换token 15天过期, 过期需要重新登录
export const LOCALE = 'locale'; // 国际化
export const HOUSE_ID = 'houseid'; // 家id
export const DATE_FORMAT = 'MM/DD/YYYY';
export const DATE_TIME_FORMAT = 'MM/DD/YYYY HH:mm:ss';
export const UI = 'ui';
export const USER_INFO = 'USER_INFO';
export const COUNTRY = 'country';
export const REGION = 'region';
export const APP_VERSION = 'appVersion';
export const ORIGIN_AND_TIME = 'WEB_ORIGIN';
export const ORIGIN_SHOP = 'SHOP';
export const SENSOR_LOGIN_ID = 'SENSOR_LOGIN_ID';

// 二次认证签名
export const SECONDARY_CERTIFICATION_SIGN = 'SIGN_SC';
// 二次登录验证码邮件发送时间
export const SECONDARY_CERTIFICATION_GET_CODE_TIME = 'SIGN_SC_LEFT';
/**
 * 无限套餐的数量，需要与 BOSS 设置保持一致
 */
export const UNLIMITED_PACKAGE_NUMBER = 999;

/**
 * PayPal 1
 * ApplePay 2
 * CreditCard 3
 */
export enum EPayMode {
  PayPal = 1,
  ApplePay = 2,
  CreditCard = 3,
}

export const payModeStringMap: any = {
  [EPayMode.PayPal]: 'PAYPAL',
  [EPayMode.CreditCard]: 'STRIPE',
};

export const PROMOTIONS_ACTIVITY_ID = '8498258fea864ac9b3c777a3e04cb674';
